import { useEffect, useState, useCallback, useContext } from 'react';
import { queryImgFileList } from '../js/request';
import { Context } from '../js/constant';
import { setUploadedImagesData } from '../actions';

type Props = {
  orderNumber?: String;
}

type CateTypes = {
  [key: string]: ImgTypes[]
}

type ImgTypes = {
  fileId: string;
  url: string;
  fileName: string;
  category: string;
  path: string
}

export default function useQueryImageListHook(props: Props) {
  const { orderNumber = '' } = props;
  const { dispatch } = useContext(Context);
  const [cateImgList, setCateImgList] = useState<CateTypes>({});

  const classifyImgList = list => {
    const cateList = {};
    list.forEach(imgItem => {
      if(!cateList[imgItem.category]) {
        cateList[imgItem.category] = [];
      }
      cateList[imgItem.category].push(imgItem);
    });
    setCateImgList(cateList);
  }

  const loadFileList = useCallback((orderNumber) => {
    queryImgFileList({ orderNumber })
      .then(data => {
        classifyImgList(data || [])
      })
      .catch(err => {})
  }, []);

  const reloadList = () => {
    loadFileList(orderNumber);
  }

  useEffect(() => {
    dispatch(setUploadedImagesData(cateImgList))
  }, [dispatch, cateImgList])

  useEffect(() => {
    if (!orderNumber) return;
    loadFileList(orderNumber)
  }, [orderNumber, loadFileList]);

  return {
    cateImgList,
    setCateImgList,
    reloadList
  }
}
